export const selfVisible = "Visible Only to You";